export default __webpack_public_path__ + "static/media/btn-store-top.f07bdedf.svg";